export default "__VITE_ASSET__BflWu_Z8__"